import React from "react";
import styled from "styled-components";

import { THEME_COLORS } from "../../../../ThemeConfig";

import bell from "../../../../assets/icons/bell_black.svg";

const NotificationCard = ({ data, large }) => {
    return (
        <Card key={data.id} isRead={data.read} large={large}>
            <Left large={large}>
                <ImageBox>
                    <img src={bell} alt="bell icon" />
                </ImageBox>
            </Left>
            <Right>
                <RightTop>
                    <Title large={large} isRead={data.isread}>
                        {data.title}
                    </Title>
                </RightTop>
                <Content large={large} isRead={data.isread}>
                    {data?.content?.length > 96
                        ? `${data.message.substring(0, 96)}...`
                        : data.message}
                </Content>
                <Time>{data.date}</Time>
            </Right>
        </Card>
    );
};

export default NotificationCard;

const Card = styled.div`
    width: 100%;
    background: ${(props) => !props.isRead ? THEME_COLORS.chips_green_container : THEME_COLORS.card_bg};
    border: 1px solid ${(props) =>
        props.isRead ? THEME_COLORS.light_300 : THEME_COLORS.primary};
    padding: ${(props) => (props.large ? "16px" : "12px")};
    margin-bottom: ${(props) => (props.large ? "12px" : "8px")};
    display: flex;
    align-items: flex-start;
    gap: 12px;
    align-self: stretch;
    border-radius: 12px;
    box-shadow: ${THEME_COLORS.elevation_user_u4};
    &:last-child {
        margin-bottom: 0;
    }
`;
const Left = styled.div`
    margin-right: 0;
    flex-shrink: 0;
`;
const ImageBox = styled.div`
    width: 40px;
    height: 40px;
    background: ${THEME_COLORS.surface_soft};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
`;
const Right = styled.div`
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
`;
const RightTop = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
`;
const Title = styled.h5`
    font-family: "DM_sans_medium";
    font-size: ${(props) => (props.large ? "16px" : "14px")};
    color: ${THEME_COLORS.text_title};
    margin: 0;
    line-height: 1.4;
    @media screen and (max-width: 540px) {
        font-size: ${(props) => (props.large ? "15px" : "14px")};
    }
`;
const Content = styled.p`
    font-family: "DM_sans";
    color: ${THEME_COLORS.text_para};
    font-size: ${(props) => (props.large ? "14px" : "13px")};
    margin: 0 0 4px;
    line-height: 1.5;
    @media screen and (max-width: 540px) {
        font-size: ${(props) => (props.large ? "13px" : "12px")};
    }
`;
const Time = styled.p`
    font-family: "DM_sans";
    font-size: 12px;
    color: ${THEME_COLORS.text_label};
    margin: 0 0 0 auto;
`;
